import React from 'react';
import ButtonGroup from 'components/shared/button-group/button-group';
import LocalizedMessage from 'common/localized-message';
import embeddedData from 'hudl-base/src/embedded-data';
import * as TeamSortTypes from 'common/team-sort-types';
import _ from 'underscore';
import { FormModifier, SingleSelect } from 'components/shared/uniform';

import './team-controls.scss';

class TeamControls extends React.Component {
  static propTypes = {
    user: React.PropTypes.shape({
      isPrivilegedUser: React.PropTypes.bool,
    }),
    team: React.PropTypes.shape({
      teamId: React.PropTypes.string.isRequired,
    }).isRequired,
    seasons: React.PropTypes.arrayOf(React.PropTypes.shape({
      seasonId: React.PropTypes.string.isRequired,
      seasonLabel: React.PropTypes.string.isRequired,
      seasonYear: React.PropTypes.number.isRequired,
      isSelected: React.PropTypes.bool,
    })).isRequired,
    teamSortType: React.PropTypes.oneOf(Object.keys(TeamSortTypes).map(key => TeamSortTypes[key])).isRequired,
    onSeasonSelect: React.PropTypes.func.isRequired,
    onSortSelect: React.PropTypes.func.isRequired,
    forcePublicView: React.PropTypes.bool,
  }

  getSelectedSeason() {
    const selectedSeason = this.props.seasons.find((season) => season.isSelected); // eslint-disable-line react/prop-types, max-len
    if (selectedSeason) {
      return selectedSeason.seasonId;
    }

    return undefined;
  }

  getSeasonOptions() {
    const seasonOptions = [];

    _.sortBy(this.props.seasons, season => {
      return season.seasonYear;
    }).reverse().forEach(season => {
      seasonOptions.push({
        label: `${season.seasonYear} - ${season.seasonYear + 1}`,
        value: season.seasonId,
      });
    });
    return seasonOptions;
  }

  getSortOptions() {
    const sort = this.props.teamSortType;
    const anyJerseyNumbers = this.props.seasons.some(season =>
      season.athletes.some(athlete => !isNaN(athlete.jerseyNumber)));
    const sortOptions = [];
    for (const key in TeamSortTypes) {
      if (TeamSortTypes.hasOwnProperty(key)) {
        const value = TeamSortTypes[key];
        let label;

        switch (value) {
        case TeamSortTypes.ALPHABETICAL:
          label = 'A - Z';
          break;
        case TeamSortTypes.JERSEY_NUMBER:
          if (!anyJerseyNumbers) {
            continue;
          }
          label = 'Jersey #';
          break;
        case TeamSortTypes.MOST_VIEWS:
          label = 'Most Views';
          break;
        default:
          continue;
        }

        sortOptions.push({
          label: label,
          value: value,
          isSelected: sort === key,
        });
      }
    }
    return sortOptions;
  }

  render() {
    let updateRosterButton;
    const rosterUrl = embeddedData.services.rosterUrl;
    const localizedMessageId = rosterUrl.indexOf('/roster') > -1 ?
        'profiles.team.update_roster_label' :
        'profiles.team.update_members_label';
    if (this.props.user && this.props.user.isPrivilegedUser && !this.props.forcePublicView) {
      updateRosterButton = (
        <a className="uni-btn--secondary--minimal uni-btn--small update-roster-button" href={rosterUrl}>
          <LocalizedMessage id={localizedMessageId}/>
        </a>
      );
    }

    return (
      <div className="team-controls">
        <div className="sort-toggle">
          <ButtonGroup buttons={this.getSortOptions()}
            onButtonPressed={this.props.onSortSelect}/>
        </div>

        <div className="season-switcher">
          <FormModifier size="small">
            <SingleSelect
              defaultValue={this.getSelectedSeason()}
              options={this.getSeasonOptions()}
              onChange={this.props.onSeasonSelect}
              hideDismiss
            />
          </FormModifier>
        </div>

        {updateRosterButton}
      </div>
    );
  }
}

export default TeamControls;
